<template>
  <el-dialog
    title="全服排行榜黑名单"
    :visible.sync="dialogVisible"
    width="900px"
    append-to-body
    :before-close="handleBeforeClose"
    custom-class="rank-black-list-dialog"
  >
    <div class="rank-black-list" v-loading="rankLoading || detailLoading">
      <p class="desc">
        查询地图内的已上云的全服排行榜，可对玩家进行拉黑操作，拉黑后该玩家将不记入任何全服榜单。
      </p>
      <div class="tab-list" v-if="rankList.length">
        <div
          v-for="(item, index) in rankList"
          :key="item.rank_name || index"
          :class="['tab-item', { active: activeRankIndex === index }]"
          @click="changeRankTab(index)"
        >
          {{ item.rank_name }}
        </div>
      </div>
      <div class="empty-tip" v-else-if="!rankLoading">暂无排行榜数据</div>

      <template v-if="rankList.length">
        <div class="filter-bar">
          <span class="filter-label">迷你号</span>
          <el-input
            v-model="searchKey"
            class="search-input"
            placeholder="请输入迷你号"
            clearable
            @keyup.enter.native="handleSearch"
          ></el-input>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-checkbox v-model="onlyBlacklisted" class="black-filter">
            仅显示已拉黑
          </el-checkbox>
        </div>
        <el-table :data="displayList" border stripe max-height="420">
          <el-table-column label="排名" width="80" align="center">
            <template slot-scope="scope">
              {{ scope.row.rank != null ? scope.row.rank : '-' }}
            </template>
          </el-table-column>
          <el-table-column
            label="昵称"
            prop="key_name"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            label="迷你号"
            prop="key"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            label="计分"
            prop="value"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.value != null ? scope.row.value : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="管理" width="100" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                :class="{ 'restore-btn': scope.row.isBlacklisted }"
                :loading="actionKey === scope.row.key"
                @click="toggleBlack(scope.row)"
              >
                {{ scope.row.isBlacklisted ? '还原' : '拉黑' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="empty-tip" v-if="!detailLoading && !displayList.length">
          暂无数据
        </div>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import {
  getMapRank,
  getMapRankDetail,
  getMapRankBlack,
  setMapRankBlack,
} from '@/api/charts';

export default {
  name: 'rankBlackList',
  props: {
    visible: { type: Boolean, default: false },
    mapId: { type: String, default: '' },
  },
  data() {
    return {
      rankLoading: false,
      detailLoading: false,
      rankList: [],
      detailList: [],
      blackList: [],
      activeRankIndex: 0,
      searchKey: '',
      searchKeyword: '',
      onlyBlacklisted: false,
      actionKey: null,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    activeRank() {
      return this.rankList[this.activeRankIndex] || null;
    },
    blackKeySet() {
      return new Set(this.blackList.map(item => item.key));
    },
    mergedList() {
      const detailKeySet = new Set();
      const merged = this.detailList.map(item => {
        detailKeySet.add(item.key);
        return {
          ...item,
          isBlacklisted: this.blackKeySet.has(item.key),
        };
      });
      this.blackList.forEach(item => {
        if (!detailKeySet.has(item.key)) {
          merged.push({
            key: item.key,
            key_name: item.key_name || '',
            value: undefined,
            rank: undefined,
            isBlacklisted: true,
          });
        }
      });
      return merged;
    },
    displayList() {
      let list = this.mergedList;
      if (this.onlyBlacklisted) {
        list = list.filter(item => item.isBlacklisted);
      }
      if (this.searchKeyword) {
        list = list.filter(item =>
          String(item.key).includes(this.searchKeyword),
        );
      }
      return list;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchRankList();
      } else {
        this.resetState();
      }
    },
  },
  methods: {
    handleBeforeClose(done) {
      this.closeDialog();
      done();
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    resetState() {
      this.rankList = [];
      this.detailList = [];
      this.blackList = [];
      this.activeRankIndex = 0;
      this.searchKey = '';
      this.searchKeyword = '';
      this.onlyBlacklisted = false;
      this.rankLoading = false;
      this.detailLoading = false;
      this.actionKey = null;
    },
    resetFilter() {
      this.searchKey = '';
      this.searchKeyword = '';
      this.onlyBlacklisted = false;
    },
    isBlacklisted(key) {
      return this.blackKeySet.has(key);
    },
    normalizeList(list) {
      return Array.isArray(list) ? list : [];
    },
    normalizeBlackList(list) {
      return this.normalizeList(list).filter(item => item?.key != null);
    },
    handleSearch() {
      this.searchKeyword = String(this.searchKey || '').trim();
    },
    changeRankTab(index) {
      if (this.activeRankIndex === index) return;
      this.activeRankIndex = index;
      this.resetFilter();
      this.fetchRankData();
    },
    fetchRankList() {
      if (!this.mapId) {
        this.$message.error('地图id不存在');
        return;
      }
      this.rankLoading = true;
      getMapRank({
        mapid: this.mapId,
      })
        .then(res => {
          if (res.code === 0) {
            this.rankList = this.normalizeList(res.data?.list);
            this.activeRankIndex = 0;
            this.resetFilter();
            if (this.rankList.length) {
              this.fetchRankData();
            } else {
              this.detailList = [];
              this.blackList = [];
            }
          } else {
            this.rankList = [];
            this.detailList = [];
            this.$message.error(res.msg || '获取排行榜列表失败');
          }
        })
        .catch(err => {
          this.rankList = [];
          this.detailList = [];
          this.$message.error(err?.msg || err || '获取排行榜列表失败');
        })
        .finally(() => {
          this.rankLoading = false;
        });
    },
    fetchRankData() {
      const rankName = this.activeRank?.rank_name;
      if (!this.mapId || !rankName) return;
      this.detailLoading = true;
      Promise.all([
        getMapRankDetail({
          mapid: this.mapId,
          rank_name: rankName,
        }),
        getMapRankBlack({
          mapid: this.mapId,
        }),
      ])
        .then(([detailRes, blackRes]) => {
          if (detailRes.code === 0) {
            this.detailList = this.normalizeList(detailRes.data?.list).map(
              (item, index) => ({
                ...item,
                rank: index + 1,
              }),
            );
          } else {
            this.detailList = [];
            this.$message.error(detailRes.msg || '获取排行榜详情失败');
          }
          if (blackRes.code === 0) {
            this.blackList = this.normalizeBlackList(blackRes.data?.list);
          } else {
            this.blackList = [];
          }
        })
        .catch(err => {
          this.detailList = [];
          this.blackList = [];
          this.$message.error(err?.msg || err || '获取排行榜数据失败');
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },
    toggleBlack(row) {
      if (!this.mapId || row?.key == null) return;
      const isBlack = this.isBlacklisted(row.key);
      const confirmOptions = isBlack
        ? {
            title: '确定要还原该玩家吗？',
            message:
              '还原后该玩家将重新记入全服排行榜，积分将重新开始累计。',
          }
        : {
            title: '确定要拉黑该玩家吗？',
            message:
              '拉黑后会清理他所有上云排行榜的数据，并后续不会再记录他的数据。',
          };
      this.$confirm(confirmOptions.message, confirmOptions.title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.submitBlack(row, isBlack);
        })
        .catch(() => {});
    },
    submitBlack(row, isBlack) {
      const flag = isBlack ? 0 : 1;
      this.actionKey = row.key;
      setMapRankBlack({
        mapid: this.mapId,
        keys: row.key,
        flag,
      })
        .then(res => {
          if (res.code === 0) {
            this.$message.success(isBlack ? '还原成功' : '拉黑成功');
            this.fetchRankData();
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        })
        .catch(err => {
          this.$message.error(err?.msg || err || '操作失败');
        })
        .finally(() => {
          this.actionKey = null;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.rank-black-list {
  min-height: 120px;

  .desc {
    margin: 0 0 16px;
    color: #595959;
    font-size: 14px;
    line-height: 22px;
  }

  .tab-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;

    .tab-item {
      padding: 8px 16px;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      background: #fff;
      color: #262626;
      font-size: 14px;
      line-height: 20px;
      cursor: pointer;
      user-select: none;

      &.active {
        border-color: #409eff;
        color: #409eff;
      }
    }
  }

  .filter-bar {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .filter-label {
      margin-right: 8px;
      color: #262626;
      font-size: 14px;
      white-space: nowrap;
    }

    .search-input {
      width: 200px;
      margin-right: 12px;
    }

    .black-filter {
      margin-left: 24px;
    }
  }

  .empty-tip {
    color: #909399;
    font-size: 14px;
    padding: 24px 0;
    text-align: center;
  }

  ::v-deep .restore-btn {
    color: #f56c6c;

    &:hover,
    &:focus {
      color: #f78989;
    }
  }
}
</style>
<style lang="scss">
.rank-black-list-dialog {
  .el-dialog__body {
    padding-top: 10px;
  }
}
</style>
